/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowRightToLineIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M34 9.5v21c0 .875-.687 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5v-21c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5m-8.5 11.625-8.5 8c-.625.563-1.562.5-2.125-.062-.562-.625-.562-1.563.063-2.125l5.75-5.438H7.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h13.188l-5.75-5.375c-.626-.562-.626-1.5-.063-2.125s1.5-.625 2.125-.062l8.5 8c.313.312.5.687.5 1.062 0 .438-.187.813-.5 1.125"/>}
        </IconWrapper>);
}
